var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCircleRedCrossRounded = function SvgIconCircleRedCrossRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.467,
    cy: 11.824,
    r: 11.324,
    fill: "#ED1639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M6.333 6.691 16.6 16.961M16.602 6.691l-10.27 10.27"
  })));
};
export { SvgIconCircleRedCrossRounded as ReactComponent };
export default __webpack_public_path__ + "images/Icon_Circle_Red_Cross_Rounded.svg";